import { List } from "@bookingcom/bui-react";
import React from "react";
import useSearchResultsListDesktopController from "./useSearchResultsList.desktop.controller.js";
import Frame from "../Frame/index.js";
import { FlightCampaignTCBanner } from "../FlightCampaignTCBanner/index.js";
import FlightCardWrapper from "./FlightCardWrapper.js";
import FlightCardDesktop from "../FlightCard/FlightCard.desktop.js";
import { getVisibleFlights } from "./utils.js";
const SearchResultsListInboundDesktop = ({ flights, onSelectFlight, outboundBrandedFareName }) => {
    const { campaignBanner } = useSearchResultsListDesktopController();
    const visibleFlights = getVisibleFlights(flights);
    return (React.createElement(List, { attributes: { style: { padding: 0 } } },
        visibleFlights.map((flight, index) => {
            return (React.createElement("div", { key: `${index}_${flight.token}` },
                campaignBanner && index === campaignBanner.position ? (React.createElement(Frame, { mt: 2, mb: 4 },
                    React.createElement(FlightCampaignTCBanner, { campaignBanner: campaignBanner }))) : null,
                React.createElement(FlightCardWrapper, { index: index, total: visibleFlights.length },
                    React.createElement(FlightCardDesktop, { flight: flight, index: index, outboundBrandedFareName: outboundBrandedFareName, onClick: onSelectFlight })),
                campaignBanner &&
                    campaignBanner.position >= visibleFlights.length &&
                    index >= visibleFlights.length - 1 ? (React.createElement(Frame, { mt: 2, mb: 4 },
                    React.createElement(FlightCampaignTCBanner, { campaignBanner: campaignBanner }))) : null));
        }),
        " "));
};
export default React.memo(SearchResultsListInboundDesktop);
